module.exports = __webpack_public_path__ + "img/目标6.34241ba9.png";